import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * Ask AllTrails mode on /explore. While it's active the sidebar shows Ask, the map shows only Ask's pins, and the hosting
 * page's own searches and pin updates are paused without touching Explore's state.
 *
 * Deliberately left out of `useResetState`, so Back from a page can return to Ask.
 */
export type AskState = {
  isActive: boolean;
  /**
   * Whether a page that hosts Ask is mounted. Ask stays active as the user moves between pages, but only a host page shows
   * it; a page becomes a host by calling `useAskMode`.
   */
  isAvailable: boolean;
};

export const initialState: AskState = {
  isActive: false,
  isAvailable: false
};

export const askSlice = createSlice({
  name: 'ask',
  initialState,
  reducers: {
    enterAsk: state => {
      state.isActive = true;
    },
    exitAsk: state => ({ ...initialState, isAvailable: state.isAvailable }),
    setIsAskAvailable: (state, action: PayloadAction<boolean>) => {
      state.isAvailable = action.payload;
    }
  }
});

export const { enterAsk, exitAsk, setIsAskAvailable } = askSlice.actions;

export default askSlice.reducer;
